import { render, staticRenderFns } from "./ModalMetadatos.vue?vue&type=template&id=006a31b2&"
import script from "./ModalMetadatos.vue?vue&type=script&lang=js&"
export * from "./ModalMetadatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports